/**
 * This file contains constants that are only used by the album-receiver and are not to be seen by the other products
 */

export const SENTRY_DSN__ALBUM_RECEIVER = 'https://103b2c99477249f98a706789b6d275ba@sentry.io/129599';
